
const color_palette_list = [
    { name: "HotPink ", color: "#FF69B4" },
    { name: "MediumOrchid ", color: "#BA55D3" },
    { name: "RebeccaPurple ", color: "#663399" },
    { name: "DarkSalmon ", color: "	#E9967A" },
    { name: "FireBrick ", color: "#B22222" },
    { name: "DarkOrange ", color: "#FF8C00" },
    { name: "Tomato ", color: "	#FF6347" },
    { name: "Moccasin ", color: "#FFE4B5" },
    { name: "DarkKhaki ", color: "#BDB76B" },
    { name: "Lime ", color: "#00FF00" },
    { name: "red", color: "red" },
    { name: "green", color: "green" },
    { name: "blue", color: "blue" },
    { name: "yellow", color: "yellow" },
    { name: "pink", color: "pink" },
    { name: "white", color: "white" },
    { name: "gray", color: "gray" },
    { name: "black", color: "black" },
    { name: "lightblue", color: "lightblue" },
    { name: "cyan", color: "cyan" }
]
export default color_palette_list;